import React from "react";

import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import { useUser } from "components/helper/userContext";
import { logOut } from "components/helper/callApi";

import { ERROR } from "types/snackBar.constant";
type Props = {
    children: React.ReactElement<React.ButtonHTMLAttributes<HTMLButtonElement>>;
};

const LogoutWrapper = ({ children }: Props) => {
    const { setUser } = useUser();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogOut = async () => {
        try {
            await logOut();
            setUser(null);
            navigate("/", { replace: true });
        } catch {
            enqueueSnackbar(`${t("errorUnknown")}`, {
                variant: ERROR,
            });
        }
    };

    const element = React.Children.only(children);
    return React.cloneElement(element, { onClick: handleLogOut });
};

export default LogoutWrapper;
